import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import { useHistory } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import { NeoOTP, NeoSuccess } from '../../../components/FormComponents'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../../components/Modal/Modal'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import { AddInternationalBeneficiarySchema } from '../../../schemas/transfers'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import BeneficiaryService from '../../../services/beneficiary.service'
import { ADD_BENEFICIARY_KEYS, BUTTON_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
const internationalBeneConfig = validationConfig['addBeneficiary']['international']
import config from 'custom/config/environment'

const modeOfTransferList = [
  { label: 'SWIFT / BIC', value: 'BIC' },
  { label: 'IFSC', value: 'IFSC' },
  { label: 'Routing', value: 'ROUTE' },
]

export default function AddInternationalBeneficiary() {
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [formValues, setFormValues] = useState({
    benName: '',
    nickName: '',
    accountNumber: '',
    confirmAccountNumber: '',
    bankName: '',
    bankBranch: '',
    maxTransferAmount: '',
    transferAmount: undefined,
    beneEmail: '',
    beneMobileNo: '',
    beneCountry: '',
    bankCountry: '',
    beneAddress: '',
    modeofTransfer: 'SWIFT / BIC',
    code: '',
    bankAddress: '',
    isVisibleToGroup: false,
  })
  const [countries, setCountries] = useState([])
  const [message, setMessage] = useState('')
  const [verifyDetails, setVerifyDetails] = useState({})
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    getSwiftCountry()
  }, [])

  // const fetchCountries = useCallback(async () => {
  //   const response = await getCountries()
  //   setCountries(response)
  // }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath='/transfers' />
      default:
        return renderForm()
    }
  }

  const getSwiftCountry = useCallback(async () => {
    try {
      const response = await BeneficiaryService.getSwiftCountry({})
      if (response.status === 200) {
        setCountries(response.data['country'])
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  const onVerify = useCallback(
    async (data) => {
      try {
        if (data.transferAmount < config.MIN_TRANSFER_LIMIT) {
          return
        }
        setLoading(true)
        setFormValues(data)
        const response = await BeneficiaryService.verifyInternationalBeneficiary(data)
        if (response.status === 200) {
          setVerifyDetails(response.data)
          setOtpEnabled(response.data['otpEnable'])
          setLoading(false)
          setStage(2)
        }
      } catch (err) {
        setLoading(false)
        setMessage(err?.data)
        //showModal()
      }
    },
    [countries],
  )

  const onConfirm = useCallback(async () => {
    setLoading(true)
    try {
      const reqParams = {
        ...verifyDetails,
        ...formValues,
        otp: otp,
      }
      const response = await BeneficiaryService.confirmInternationalBeneficiary(reqParams)
      if (response.status === 200) {
        setMessage(response.data.message)
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setMessage(err?.data)
      setOtp('')
      //showModal()
    }
  }, [formValues, otp, verifyDetails])

  function renderForm() {
    return (
      <div>
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={AddInternationalBeneficiarySchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    value={values.benName}
                    showAsterisk={internationalBeneConfig['isBeneNameRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BENEFICIARY_NAME)}
                    name='benName'
                    onChange={handleChange}
                    minLength={2}
                    maxLength={32}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32 &&
                        !(event.charCode >= 48 && event.charCode <= 57) &&
                        event.charCode !== 95
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.benName} touched={touched.benName} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={internationalBeneConfig['isNickNameRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.NICK_NAME)}
                    value={values.nickName}
                    name='nickName'
                    minLength={7}
                    maxLength={34}
                    onChange={handleChange}
                    onKeyPress={(event) => {
                      if (
                        //!(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32 &&
                        !(event.charCode >= 48 && event.charCode <= 57) &&
                        event.charCode !== 95
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.nickName} touched={touched.nickName} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={internationalBeneConfig['isAccountNoRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.ACCOUNT_NO)}
                    name='accountNumber'
                    minLength={5}
                    maxLength={20}
                    mode='password'
                    onChange={(value) => {
                      setFieldValue('accountNumber', value?.value)
                    }}
                  />
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='4'
                    showAsterisk={internationalBeneConfig['isConfirmAccountNoRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.CONFIRM_ACCOUNT_NO)}
                    mode='onlyNumber'
                    onChange={(value) => {
                      setFieldValue('confirmAccountNumber', value?.value)
                    }}
                    name='confirmAccountNumber'
                  />
                  <InputError
                    text={errors.confirmAccountNumber}
                    touched={touched.confirmAccountNumber}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='5'
                    value={values.beneAddress}
                    showAsterisk={internationalBeneConfig['isAddressRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.ADDRESS)}
                    name='beneAddress'
                    onChange={handleChange}
                  />
                  <InputError text={errors.beneAddress} touched={touched.beneAddress} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='6'
                    mode='select'
                    showAsterisk={internationalBeneConfig['isBeneCountryRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BENEFICIARY_COUNTRY)}
                    placeholder={t(ADD_BENEFICIARY_KEYS.BENEFICIARY_COUNTRY)}
                    name='beneCountry'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={countries}
                    value={values.beneCountry}
                  />
                  <InputError text={errors.beneCountry} touched={touched.beneCountry} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='7'
                    mode='select'
                    showAsterisk={internationalBeneConfig['isModeOfTransferRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.MODE_OF_TRANSFER)}
                    placeholder={t(ADD_BENEFICIARY_KEYS.MODE_OF_TRANSFER)}
                    name='modeofTransfer'
                    onChange={handleChange}
                    keyValue='label'
                    list={modeOfTransferList}
                    value={values.modeofTransfer}
                  />
                  <InputError text={errors.modeofTransfer} touched={touched.modeofTransfer} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='8'
                    mode='single'
                    name='code'
                    text={
                      values.modeofTransfer === 'SWIFT / BIC'
                        ? `${t(ADD_BENEFICIARY_KEYS.SWIFT_BIC_CODE)} *`
                        : values.modeofTransfer === 'IFSC'
                        ? `${t(ADD_BENEFICIARY_KEYS.IFSC_CODE)} *`
                        : `${t(ADD_BENEFICIARY_KEYS.ROUTING_NUMBER)} *`
                    }
                    value={values.code}
                    onChange={handleChange}
                    minLength={8}
                    maxLength={11}
                  />
                  <InputError text={errors.code} touched={touched.code} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='9'
                    value={values.bankName}
                    showAsterisk={internationalBeneConfig['isBeneBankRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BENEFICIARY_BANK)}
                    name='bankName'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankName} touched={touched.bankName} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='10'
                    value={values.bankBranch}
                    showAsterisk={internationalBeneConfig['isBranchRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BRANCH_NAME)}
                    name='bankBranch'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankBranch} touched={touched.bankBranch} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='11'
                    value={values.bankAddress}
                    showAsterisk={internationalBeneConfig['isBankAddressRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BANK_ADDRESS)}
                    name='bankAddress'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankAddress} touched={touched.bankAddress} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='12'
                    mode='select'
                    showAsterisk={internationalBeneConfig['isBankCountryRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BANK_COUNTRY)}
                    placeholder={t(ADD_BENEFICIARY_KEYS.BANK_COUNTRY)}
                    name='bankCountry'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={countries}
                    value={values.bankCountry}
                  />
                  <InputError text={errors.bankCountry} touched={touched.bankCountry} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='13'
                    showAsterisk={internationalBeneConfig['isEmailRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BENE_EMAIL_ID)}
                    name='beneEmail'
                    value={values.beneEmail}
                    onChange={handleChange}
                    maxLength='30'
                  />
                  <InputError text={errors.beneEmail} touched={touched.beneEmail} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='14'
                    showAsterisk={internationalBeneConfig['isMobileNoRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.BENE_MOBILE_NO)}
                    onChange={(value) => {
                      setFieldValue('beneMobileNo', value?.value)
                    }}
                    mode='onlyNumber'
                    name='beneMobileNo'
                    minLength={8}
                    maxLength={15}
                  />
                  <InputError text={errors.beneMobileNo} touched={touched.beneMobileNo} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='15'
                    showAsterisk={internationalBeneConfig['isTransferLimitRequired']}
                    text={t(ADD_BENEFICIARY_KEYS.TRANSFER_LIMIT)}
                    mode='amount'
                    onChange={(value) => {
                      setFieldValue('transferAmount', value?.floatValue)
                      setFieldValue('maxTransferAmount', value?.value)
                    }}
                    name='maxTransferAmount'
                  />
                  <InputError text={errors.maxTransferAmount} touched={touched.maxTransferAmount} />
                  <InputError
                    text={`${t(ADD_BENEFICIARY_KEYS.TRANSFER_LIMIT_TXT)} ${
                      config.MIN_TRANSFER_LIMIT
                    }.00`}
                    touched={values.transferAmount < config.MIN_TRANSFER_LIMIT}
                  />
                </div>
              </div>

              <div className='form-check'>
                <Field
                  tabIndex={'16'}
                  as='input'
                  id='visibleGroup'
                  type='checkbox'
                  className='form-check-input'
                  name='isVisibleToGroup'
                />
                <label className='form-check-label' htmlFor='visibleGroup'>
                  {t(ADD_BENEFICIARY_KEYS.VISIBLE_GROUP)}
                </label>
              </div>

              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='17'
                    type='submit'
                    mode='newDesign'
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  tabIndex={'18'}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  onClick={() => history.goBack()}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BENEFICIARY_NAME)}</h6>
          <h6 className='value'>{formValues.benName}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.NICK_NAME)}</h6>
          <h6 className='value'>{formValues.nickName}</h6>
        </div>

        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.ACCOUNT_NO)}</h6>
          <h6 className='value'>{formValues.accountNumber}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.ADDRESS)}</h6>
          <h6 className='value'>{formValues.beneAddress}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BENEFICIARY_COUNTRY)}</h6>
          <h6 className='value'>{formValues.beneCountry}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.MODE_OF_TRANSFER)}</h6>
          <h6 className='value'>{formValues.modeofTransfer}</h6>
        </div>
        <div>
          <h6 className='label'>
            {formValues.modeofTransfer === 'SWIFT / BIC' ? (
              <label>{t(ADD_BENEFICIARY_KEYS.SWIFT_BIC_CODE)}</label>
            ) : (
              ''
            )}
            {formValues.modeofTransfer === 'IFSC' ? (
              <label>{t(ADD_BENEFICIARY_KEYS.IFSC_CODE)}</label>
            ) : (
              ''
            )}
            {formValues.modeofTransfer === 'Routing' ? (
              <label>{t(ADD_BENEFICIARY_KEYS.ROUTING_NUMBER)}</label>
            ) : (
              ''
            )}
          </h6>
          <h6 className='value'>{formValues.code}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BANK_ADDRESS)}</h6>
          <h6 className='value'>{formValues.bankAddress}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BANK_COUNTRY)}</h6>
          <h6 className='value'>{formValues.bankCountry}</h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.TRANSFER_LIMIT)}</h6>

          <h6 className='value'>
            <NumberFormat
              value={formValues.maxTransferAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BRANCH_NAME)}</h6>
          <h6 className='value'>{formValues.bankBranch}</h6>
        </div>

        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BENE_EMAIL_ID)}</h6>
          <h6 className='value'>{formValues.beneEmail}</h6>
        </div>

        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.BENE_MOBILE_NO)}</h6>
          <h6 className='value'>{formValues.beneMobileNo}</h6>
        </div>

        <div>
          <h6 className='label'>{t(ADD_BENEFICIARY_KEYS.VISIBLE_GROUP)}</h6>
          <h6 className='value'>{formValues.isVisibleToGroup ? 'Yes' : 'No'}</h6>
        </div>

        <div>
          <TermsAndCondition module='BENEFICIARY' />
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(BUTTON_KEYS.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          {t(BUTTON_KEYS.BACK)}{' '}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='BENE_INTERNATIONAL'>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(ADD_BENEFICIARY_KEYS.INTERNATIONAL_BENE_HEADER)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
